const fileDownload = require("js-file-download");
const { PII_MASK_CHARACTER, PII_MASK_DOT_CHARACTER } = require("./constant");

const isDeleteAuthorisedUser = (user = {}) =>
  user?.access_type?.includes("delete_bank_payment");

const isDeleteButtonDisabled = (user = {}) => {
  return isDeleteAuthorisedUser(user) ? "block" : "none";
};

const downloadExcelFunction = (buffer, fileName, extension = "xlsx") => {
  try {
    let file_name = "";
    if (hasExtension(fileName)) {
      file_name = `${fileName}`;
    } else {
      file_name = `${fileName}.${extension}`;
    }
    fileDownload(new Blob([buffer]), `${file_name}`);
  } catch (error) {
    console.log(error);
  }
};

const hasExtension = (fileName) => {
  // Check if the fileName has a period and there is text after the period
  return fileName.includes(".") && fileName.split(".").pop().length > 0;
};

const isSuperMaker = (caseDetails = {}, user) => {
  let check = false;
  const isSuperMakerCond = user.is_super_maker && user.is_super_maker === 1;
  if (Object.keys(caseDetails).length) {
    const caseType =
      caseDetails.case_type && caseDetails.case_type === "normal"
        ? true
        : caseDetails.control_type && caseDetails.control_type === 1
          ? true
          : false;
    const superMakerEligibility =
      caseDetails.stp_payment && caseDetails.stp_payment === 1 ? true : false;
    if (
      user.id === caseDetails.maker_id &&
      isSuperMakerCond &&
      caseType &&
      superMakerEligibility
    ) {
      check = true;
    }
  } else {
    if (isSuperMakerCond) check = true;
  }
  return check;
};

const compareTrancheDetails = (
  caseDetails = {},
  tuComparable = [],
  matchKey = "",
  matchValue = "",
  saveAsDraft = 0,
  id = 0,
) => {
  let tuCheck = { match: true, class: "" };
  if (Object.keys(tuComparable).length && Object.keys(caseDetails).length) {
    if (id === caseDetails.maker_id) {
      if (
        saveAsDraft &&
        tuComparable[matchKey] &&
        tuComparable[matchKey].toString().trim().toLowerCase() !==
          matchValue.toString().trim().toLowerCase()
      ) {
        tuCheck = { match: false, class: "col-red" };
      }
    } else {
      if (
        tuComparable[matchKey] &&
        tuComparable[matchKey].toString().trim().toLowerCase() !==
          matchValue.toString().trim().toLowerCase()
      ) {
        tuCheck = { match: false, class: "col-red" };
      }
    }
  }

  return tuCheck;
};

const extractStringWithoutNumbers = (str) => {
  return str.replace(/\d+/g, "");
};

const extractNumbersFromString = (str) => {
  return /\d/.test(str) ? str.match(/\d+/g).join("") : "";
};

const maskString = (str, type = "") => {
  if (!str.trim()) return str;

  let maskedStr = str;

  switch (type) {
    case "phone":
    case "aadhar":
    case "pan_card":
    case "dl":
    case "voter_id":
    case "account_no":
      str = str.replace(/\s/g, "");
      let len = str.length - 4;
      if (len < 1) return str;
      maskedStr = PII_MASK_CHARACTER.repeat(len) + str.slice(len);
      break;

    case "otp":
      str = str.replace(/\s/g, "");
      len = str.length;
      maskedStr = PII_MASK_CHARACTER.repeat(len);
      break;

    case "email":
      str = str.replace(/\s/g, "");
      let atIndex = str.indexOf("@");
      if (atIndex === -1) return str;
      let domainLength = str.length - atIndex;
      len = str.length - domainLength;
      maskedStr = PII_MASK_CHARACTER.repeat(len) + str.slice(len);
      break;

    case "payee_acc_no":
      str = str.replace(/\s/g, "");
      if (str.length <= 6) return str;
      maskedStr =
        str.slice(0, 2) +
        PII_MASK_CHARACTER.repeat(str.length - 6) +
        str.slice(str.length - 4);
      break;

    default:
      break;
  }
  return maskedStr;
};

const maskPayeeAccountText = (str, disableValues = true) => {
  if (!str || !str.trim() || !disableValues) {
    return str;
  }

  const acNoRegex = /(LOAN\s+A\/C\s+NO|A\/C\s+NO)\s+(\S+)/i;
  const match = str.match(acNoRegex);

  if (!match) return str;

  const fullLabel = match[1];
  const accountNo = match[2];

  if (accountNo.length <= 4) return str;

  const maskedAccountNo =
    accountNo.slice(0, 2) +
    PII_MASK_DOT_CHARACTER.repeat(accountNo.length - 4) +
    accountNo.slice(-2);

  return str.replace(
    `${fullLabel} ${accountNo}`,
    `${fullLabel} ${maskedAccountNo}`,
  );
};
const getOfflinePayeeName = (details) => {
  const { payee_name, payee_account, payee_type, is_account_no_optional } =
    details;

  const isBank = Number(payee_type) === 6;
  const includeAccountNo = Number(is_account_no_optional) === 0;

  if ([2, 3, 4].includes(+details?.payment_type)) {
    if (isBank) {
      if (includeAccountNo) {
        return `${payee_name} LOAN A/C NO ${payee_account}`;
      }
      return payee_name;
    }

    if (includeAccountNo) {
      return `${payee_name} A/C NO ${payee_account}`;
    }
  }

  return payee_name;
};

const checkPayeeNameHavAcc = (payeeName = "") => {
  if (!payeeName) return false;
  const regex = /(LOAN\s+A\/C\s+NO|A\/C\s+NO)\s+.+/i;
  return regex.test(payeeName);
};

const getCleanPayeeName = (payeeName = "") => {
  if (!payeeName) return "";
  return payeeName.replace(/\s*(LOAN\s+A\/C\s+NO|A\/C\s+NO)\s+.+$/i, "").trim();
};

module.exports = {
  isDeleteAuthorisedUser,
  isDeleteButtonDisabled,
  downloadExcelFunction,
  isSuperMaker,
  compareTrancheDetails,
  extractStringWithoutNumbers,
  extractNumbersFromString,
  maskString,
  maskPayeeAccountText,
  getOfflinePayeeName,
  checkPayeeNameHavAcc,
  getCleanPayeeName,
};
